import { gql } from 'graphql-request'

export const IMAGE_FIELDS = gql`
  title
  description
  width
  height
  url
  contentType
`

export const META_INFORMATION = gql`
    title
    description
    image {
      ${IMAGE_FIELDS}
    }
    keywordsCollection {
        items {
          keyword
        }
      }
`

export const EMBEDDED_ITEMS = gql`
  links {
    assets {
      block {
        sys {
          id
        }
        ${IMAGE_FIELDS}
      }
    }
    entries {
      block {
        sys {
          id
        }
        __typename
        ... on YoutubeVideo {
          youtubeLink
        }
        __typename
        ... on CodeSnippet {
          title
          headContent
          bodyContent
        }
      }
    }
  }
`

export const STORY_CARD_FIELDS = gql`
    image {
      ${IMAGE_FIELDS}
    }
    title
    description
    publicationDate
    slug
`

export const STORY_COLLECTION_FIELDS = gql`
  items {
    title
    description
    slug
    publicationDate
    image {
      ${IMAGE_FIELDS}
    }
  }
  total
`

export const EVENT_CARD_FIELDS = gql`
    title
    description {
      json
    }
    slug
    buttonText
    eventbriteLink
    eventType
    location
    publicationDate
    image {
      ${IMAGE_FIELDS}
    }
`
